import { render, staticRenderFns } from "./CompanySustainability.vue?vue&type=template&id=3dc7e5ee&scoped=true&"
import script from "./CompanySustainability.vue?vue&type=script&lang=ts&"
export * from "./CompanySustainability.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySustainability.vue?vue&type=style&index=0&id=3dc7e5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7e5ee",
  null
  
)

export default component.exports